import {
  IDeltaHedgeExeDetailedStateTableReport,
  IDeltaHedgeExeDetailedStateTableSearchParam,
} from "../../../Interfaces/deltaHedgeExe";
import { getDeltaHedgeExeDetailedStateTable } from "../../../Requests/adjustment";
import { CommonTableUI } from "../../TableTemplate/common";
import TableTemplate from "../../TableTemplate/tableTemplate";
import { Additional } from "./Additional";

interface IProps {
  searchParams: IDeltaHedgeExeDetailedStateTableSearchParam;
  onTableRowClick: (row: IDeltaHedgeExeDetailedStateTableReport) => void;
  activeRowId?: number;
}

const DetailedStateTable = ({
  searchParams,
  onTableRowClick,
  activeRowId,
}: IProps) => {
  return (
    <TableTemplate<
      IDeltaHedgeExeDetailedStateTableSearchParam,
      IDeltaHedgeExeDetailedStateTableReport
    >
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          AdditionalBody={Additional}
          onTableRowClick={onTableRowClick}
          tableBoxClassName="!max-h-[300px] order-table"
          activeRowId={activeRowId}
          filterCols={{
            show: true,
            tableName: "DeltaHedge3DetailedStateAdjustmentOffsetDeltaGamma",
            allowedPositions: [],
          }}
        />
      )}
      getDataTable={getDeltaHedgeExeDetailedStateTable}
      searchParameters={searchParams}
      refreshTableTime={5000}
      tableWrapperClassname="!mx-0"
    />
  );
};

export default DetailedStateTable;
